export default __webpack_public_path__ + "static/media/xmas_gift_box.9fbd5b18.png";